import { sessionSet, sessionGet } from '../storage'

const prefix = 'content/'

function get(name) {
  return sessionGet(prefix + name) || ''
}

function set(name, data) {
  return sessionSet(prefix + name, data) || ''
}

export default {
  namespaced: true,
  state: {
    evaluationGameInfo: '',
    trainGameInfo: '',
    questionGroupInfo: '',
    questionnaire: '',
    questionInfo: '',
    courseVideoInfo: '',
    marketProjects: [],
    authMarksTabs: null,
    normInfo: '', // 常模信息
    abilityInfo: '', // 能力信息
  },
  getters: {
    getAbilityInfo: (state) => () => {
      if (!state.abilityInfo) {
        state.abilityInfo = get('abilityInfo')
      }
      return state.abilityInfo
    },
    getNormInfo: (state) => () => {
      if (!state.normInfo) {
        state.normInfo = get('normInfo')
      }
      return state.normInfo
    },
    getEvaluationGameInfo: (state) => () => {
      if (!state.evaluationGameInfo) {
        state.evaluationGameInfo = get('evaluationGameInfo')
      }
      return state.evaluationGameInfo
    },
    getTrainGameInfo: (state) => () => {
      if (!state.trainGameInfo) {
        state.trainGameInfo = get('trainGameInfo')
      }
      return state.trainGameInfo
    },
    getQuestionGroupInfo: (state) => () => {
      if (!state.questionGroupInfo) {
        state.questionGroupInfo = get('questionGroupInfo')
      }
      return state.questionGroupInfo
    },
    getQuestionnaireInfo: (state) => () => {
      if (!state.questionnaire) {
        state.questionnaire = get('questionnaire')
      }
      return state.questionnaire
    },
    getQuestionInfo: (state) => () => {
      if (!state.questionInfo) {
        state.questionInfo = get('questionInfo')
      }
      return state.questionInfo
    },
    getCourseVideoInfo: (state) => () => {
      if (!state.courseVideoInfo) {
        state.courseVideoInfo = get('courseVideoInfo')
      }
      return state.courseVideoInfo
    },
  },
  mutations: {
    setAbilityInfo(state, data) {
      state.abilityInfo = data
      set('abilityInfo', data)
    },
    setNormInfo(state, data) {
      state.normInfo = data
      set('normInfo', data)
    },
    setMarketProjects(state, data) {
      state.marketProjects = data
    },
    setAuthMarksTabs(state, data) {
      state.authMarksTabs = data
    },
    setEvaluationGameInfo(state, data) {
      state.evaluationGameInfo = data
      set('evaluationGameInfo', data)
    },
    setTrainGameInfo(state, data) {
      state.trainGameInfo = data
      set('trainGameInfo', data)
    },
    setQuestionGroupInfo(state, data) {
      state.questionGroupInfo = data
      set('questionGroupInfo', data)
    },
    setQuestionnaireInfo(state, data) {
      state.questionnaire = data
      set('questionnaire', data)
    },
    setQuestionInfo(state, data) {
      state.questionInfo = data
      set('questionInfo', data)
    },
    setCourseVideoInfo(state, data) {
      state.courseVideoInfo = data
      set('courseVideoInfo', data)
    },
  },
  actions: {},
}
